import cn from 'clsx';
import type {ReactNode} from 'react';

import {typographyVariants} from '@/components/Typography';

import {TRACK_TRANSITION} from './trackGeometry';

interface TrackKnobProps {
    offset: string;
    width: number;
    className?: string;
    children: ReactNode;
}

const TrackKnob = ({offset, width, className, children}: TrackKnobProps) => (
    <div
        style={{left: offset, width}}
        className={cn(
            'absolute top-1/2 flex h-11 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border-2 bg-orion-2 text-romance shadow-[0_4px_5px_rgba(0,0,0,0.25)]',
            typographyVariants.bodySmallBold,
            TRACK_TRANSITION,
            className
        )}
    >
        {children}
    </div>
);

export default TrackKnob;
